import React from 'react';

const services = [
  {
    icon: 'fas fa-heartbeat',
    title: 'Heart',
    description:
      'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum.',
  },
  {
    icon: 'fas fa-briefcase-medical',
    title: 'Medical Counseling',
    description:
      'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum.',
  },
  {
    icon: 'fas fa-notes-medical',
    title: 'Qualified Doctors',
    description:
      'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum.',
  },
  {
    icon: 'fas fa-hospital-alt',
    title: 'Emergency Services',
    description:
      'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum.',
  },
];

const Services = () => {
  return (
    <div className="service2-main-wrapper2 float_left">
      <div className="container">
        <div className="row">
          {services.map((service, index) => (
            <div
              key={index}
              className="col-lg-3 col-md-6 col-sm-12 col-12 p-0"
            >
              <section className="resp-margin">
                <div className="sb-service-section2">
                  <span className="d-inline-block">
                    <i className={service.icon}></i>
                  </span>
                  <h5>{service.title}</h5>
                  <p>{service.description}</p>
                </div>
                <div className="hover-type">
                  <a
                    href="service.html"
                    className="d-inline-block w-100 text-center"
                  >
                    View More
                  </a>
                </div>
              </section>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
